import { Box, Typography, styled } from '@mui/material';
import { ConditionDetails } from '../../types/genomic';

const NoVariantsBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

const LimitationItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const LimitationNumber = styled(Box)(({ theme }) => ({
  minWidth: '24px',
  height: '24px',
  marginTop: '3px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.875rem',
  fontWeight: 'bold',
}));
/*            <Typography component="li" variant="body2" paragraph>
              This genetic test analyzes specific regions of genes associated with {condition.name}. 
              Not all possible disease-causing variants may be detected.
            </Typography>
            <Typography component="li" variant="body2" paragraph>
              Some types of variants, such as certain structural or complex rearrangements, 
              may not be detectable by the methods used.
            </Typography>
            {(condition.inheritance_pattern || '').length == 0 && (
              <Typography component="li" variant="body2" paragraph>
                This condition may be due to a complex genetic or environmental cause or a combination of factors which this test does not address.
              </Typography>
            )}
            {condition.inheritance_pattern === 'Autosomal Dominant' && (
              <Typography component="li" variant="body2" paragraph>
                For autosomal dominant conditions like {condition.name}, a negative result 
                does not completely rule out the condition due to possible variations in 
                penetrance and expressivity.
              </Typography>
            )}
            {condition.inheritance_pattern === 'Autosomal Recessive' && (
              <Typography component="li" variant="body2" paragraph>
                For autosomal recessive conditions, this test may not detect all possible 
                disease-causing variants. A negative result does not rule out carrier status.
              </Typography>
            )}*/
export const NoVariantsFound = ({conditions}: {conditions: ConditionDetails[]}) => {
  return (
    <>
      <Typography variant="h2" gutterBottom color="primary">
        No Variants Identified
      </Typography>
      
      <NoVariantsBox>
        <Box mb={4}>
          <Typography variant="h6" color="text.primary" gutterBottom>
            Summary
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Our analysis did not identify any variants meeting our reporting criteria in the genes analyzed. While this reduces the likelihood of a genetic contribution to the condition under investigation, it does not completely rule out a genetic basis for the observed symptoms.
          </Typography>
        </Box>

        <Box mb={4}>
          <Typography variant="h6" color="text.primary" gutterBottom>
            Key Limitations
          </Typography>
          
          <LimitationItem>
            <LimitationNumber>1</LimitationNumber>
            <Typography variant="body1" color="text.secondary">
                This genetic test analyzes specific regions of genes associated with {conditions.length === 1 ? conditions[0].name : conditions.reduce((acc, condition, index) => acc + condition.name + (index < conditions.length - 1 ? ', ' : ' and '), '')}.
                Not all possible disease-causing variants may be detected.
            </Typography>
          </LimitationItem>

          <LimitationItem>
            <LimitationNumber>2</LimitationNumber>
            <Typography variant="body1" color="text.secondary">
                Some types of variants, such as certain structural or complex rearrangements, 
                may not be detectable by the methods used.
            </Typography>
          </LimitationItem>

        
        </Box>

        <Box>
          <Typography variant="h6" color="text.primary" gutterBottom>
            Next Steps
          </Typography>
          <Typography variant="body1" color="text.secondary">
            We recommend discussing these results with your healthcare provider, who can determine if additional genetic testing or other medical evaluations would be beneficial based on your specific situation.
          </Typography>
        </Box>
      </NoVariantsBox>
    </>
  );
}; 
